import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { coverageLabel } from '@ww/shared';
import WeatherMap from '../components/WeatherMap';
import { ActiveBanner, AlertFeed, StaleBanner, StatusTiles } from '../components/DashboardParts';
import { DISCLAIMER, LiveClock, Logo, PollingPill, SystemBadge } from '../components/HeaderBits';
import { useLive } from '../hooks/useLive';
import { I, Icon } from '../lib/icons';

export default function Wallboard() {
  const navigate = useNavigate();
  const { dashboard, health, assets, tenant, connected } = useLive();
  const [isFullscreen, setIsFullscreen] = useState(() => !!document.fullscreenElement);

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      void document.exitFullscreen().catch(() => undefined);
    } else {
      void document.documentElement.requestFullscreen?.().catch(() => undefined);
    }
  };

  const exit = () => {
    if (document.fullscreenElement) void document.exitFullscreen().catch(() => undefined);
    navigate('/');
  };

  return (
    <div className="wall">
      <header className="app-header wall-header">
        <Logo large />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 20,
            fontWeight: 600,
            paddingLeft: 12,
            borderLeft: '1px solid #1f2d47',
            minWidth: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Icon d={I.pin} size={18} style={{ color: '#9fb0c8' }} />
          {tenant ? coverageLabel(tenant) : 'Loading…'}
        </div>
        <PollingPill health={health} large />
        <div style={{ flexGrow: 1 }} />
        <SystemBadge health={health} connected={connected} large />
        <LiveClock tz={tenant?.timezone} large />
        <button type="button" className="btn btn-ghost btn-sm hov" onClick={toggleFullscreen} aria-pressed={isFullscreen}>
          <Icon d={I.fullscreen} size={16} />
          {isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
        </button>
        <button type="button" className="btn btn-secondary btn-sm hov" onClick={exit}>
          <Icon d={I.x} size={16} />
          Exit wallboard
        </button>
      </header>
      <div className="disclaimer" role="note" style={{ padding: '3px 20px', fontSize: 12 }}>
        {DISCLAIMER}
      </div>
      <main style={{ flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 14, padding: 16 }}>
        <ActiveBanner dashboard={dashboard} large />
        <StaleBanner health={health} tz={tenant?.timezone} large />
        <div className="wall-grid">
          <section className="panel" style={{ position: 'relative', minHeight: 360, overflow: 'hidden' }}>
            <WeatherMap tenant={tenant} alerts={dashboard?.alerts ?? []} assets={assets ?? []} autoPlay showSwaths />
          </section>
          <AlertFeed dashboard={dashboard} health={health} large />
        </div>
        <StatusTiles dashboard={dashboard} large />
      </main>
    </div>
  );
}
